import script from "./TrialExpiredModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TrialExpiredModal.vue?vue&type=script&setup=true&lang=ts"

import "./TrialExpiredModal.vue?vue&type=style&index=0&id=1d253935&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d253935"]])

export default __exports__